<div class="variations-stocks-container">
  <dx-data-grid
    #grid
    [dataSource]="variationsResource.value() ?? []"
    [showBorders]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [columnAutoWidth]="true"
    (onEditorPreparing)="onEditorPreparing($event)"
    (onSelectionChanged)="onSelectionChanged($event)">

    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate class="toolbar-left">
          <yo-date-range-box
            [selectedDates]="periodeSelected()"
            (onValueChange)="onPeriodeChanged($event)"
            [selectLevel]="DateLevelEnum.MONTH"
            [firstDateLastDay]="true">
          </yo-date-range-box>
        </div>
      </dxi-item>
      <dxi-item name="groupPanel"></dxi-item>
      <dxi-item name="columnChooserButton"></dxi-item>
      <dxi-item location="after">
        <div *dxTemplate>
          <yo-button
            iconClass="fa fa-check"
            label="Marquer à exporter"
            [theme]="ButtonThemeEnum.SAVE"
            [disabled]="!canMarkAExporter()"
            (onClick)="onMarkAExporter()">
          </yo-button>
        </div>
      </dxi-item>
      <dxi-item location="after">
        <div *dxTemplate>
          <yo-button
            iconClass="fa fa-file-export"
            label="Exporter"
            [theme]="ButtonThemeEnum.DEFAULT"
            [disabled]="!canExport()"
            (onClick)="onExport()">
          </yo-button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxo-selection mode="multiple" [selectAllMode]="'allPages'" [showCheckBoxesMode]="'always'"></dxo-selection>
    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-pager
      [visible]="true"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100, 200]"
      [showNavigationButtons]="true"
      [showInfo]="true"
      infoText="{2} variation(s)">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-column-chooser mode="select" [enabled]="true"></dxo-column-chooser>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="true"></dxo-grouping>

    <dxi-column type="selection" headerCellTemplate="selectAllHeaderTemplate"></dxi-column>
    <div *dxTemplate="let data of 'selectAllHeaderTemplate'">
      <dx-check-box
        iconSize="16px"
        [value]="selectAllValue()"
        [disabled]="selectableList().length === 0"
        (onValueChanged)="onSelectAllChanged($event)">
      </dx-check-box>
    </div>

    <dxi-column dataField="uniteProductionLibelle" caption="Unité de production"></dxi-column>
    <dxi-column dataField="compteComptableLibelle" caption="Libellé compte comptable" cellTemplate="compteComptableCellTemplate" [headerFilter]="compteComptableHeaderFilter"></dxi-column>
    <div *dxTemplate="let cell of 'compteComptableCellTemplate'">
      @if (cell.value) {
        {{ cell.value }}
      } @else {
        <yo-icon icon="fa-exclamation-triangle"
                 [theme]="IconThemeEnum.WARNING_INNER"
                 title="Certaine(s) denrée(s) ne présente(nt) aucun compte comptable"
                 size="small">
        </yo-icon> {{ cell.value || 'Non renseigné' }}
      }

    </div>

    <dxi-column dataField="statutExport" caption="Statut" cellTemplate="statusCellTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'statusCellTemplate'">
      @switch (cell.data.statutExport) {
        @case (VariationStockStatutExportEnum.A_EXPORTER) {
          <span>A exporter</span>
        }
        @case (VariationStockStatutExportEnum.EXPORTE) {
          <span>Exporté</span>
        }
        @default {
          <span>{{ isRowSelectable(cell.data) ? 'Non exporté' : 'Non exportable' }}</span>
        }
      }
    </div>

    <dxi-column dataField="dateDebut" caption="Date initiale"></dxi-column>
    <dxi-column dataField="montantDebut" caption="Montant initial HT" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
    <dxi-column dataField="dateFin" caption="Date de fin"></dxi-column>
    <dxi-column dataField="montantFin" caption="Montant final HT" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
    <dxi-column dataField="variation" caption="Variation HT" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>


  </dx-data-grid>
</div>
